import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchInventoryMasterList = ({commit}, payload) => {
    
    //console.log(JSON.stringify(payload))
    
    //commit('toggleLoadingState', true)
    axios.post('/inventoryMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setInventoryMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const emailInventoryList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/inventoryMaster/emailInventoryList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchInventoryMasterAutocompleteList = ({commit}, payload) => {

    commit('toggleInventoryMasterLoadingState', true)
    axios.post('/inventoryMaster/autocomplete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(payload.sales_form_request) {
            commit('setItemAutocompleteList', res.data.response)            
        } else {
            commit('setInventoryMasterAutocompleteList', res.data.response)
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleInventoryMasterLoadingState', false)
    })
    
}

export const fetchInventoryMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/inventoryMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            if(res.data.response.auto_complete_list.length>0) {            
                commit('setItemAutocompleteList', res.data.response.auto_complete_list)
            }
            if(res.data.response.auto_complete_list_inventory.length>0) {   
                commit('setInventoryMasterAutocompleteList', res.data.response.auto_complete_list_inventory)
            }
            if(payload.copy) {
                res.data.response.id = 0
                res.data.response.sku_code = ''
                res.data.response.auto_generated_sku_code = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
                dispatch('fetchItemSubCategoryList', {type: res.data.item_type})
            }
            
            commit('setInventoryMasterData', {response: res.data.response, copy: payload.copy})   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetInventoryMasterData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitInventoryMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.popup) {
                dispatch('fetchInventoryMasterData', {id: res.data.id})
            } else if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
            document.getElementById('sku_code').focus();
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteInventoryMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/inventoryMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchInventoryMasterList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadInventoryStatement = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/inventoryMaster/statement.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {   
        commit('setInventoryMasterStatementList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const prepareInventoryPriceSheet = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    if(payload.source == 'stock_check_source') {
        setTimeout(() => {
            commit('toggleLoadingState', false)
            commit('displayMessageAlert', {message: 'The sheet may take some time to get uploaded and process. We will email you once processed.', type: 'Info'})
        }, 2000);
        
    }

    axios.post('/exportModule/inventory/prepareSheet.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            if(payload.source) {
                if(payload.source == 'ibt') {
                    commit('setInventoryIntraBranchItemListRow', res.data.response)
                    setTimeout(() => {
                        commit('toggleLoadingState', false)
                    }, 2000);
                } else if(payload.source == 'external_source') {
                    commit('setInventorySourcingItemListRow', res.data.response)
                    setTimeout(() => {
                        commit('toggleLoadingState', false)
                    }, 2000);
                } else if(payload.source == 'stock_check_source') {
                    commit('setInventoryStockCheckItemListRow', res.data.response)
                }
            } else {
                commit('setImportInventoryDiscountData', res.data.response)
            }
            
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
            commit('toggleLoadingState', false)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const submitImportInventoryPriceData = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/exportModule/inventory/submitData.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        commit('resetImportInventoryDiscountData', res.data)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchSingleItemStock = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/inventoryMaster/fetchSingleItemStock.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setItemStockCheckList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryMaster/actions.js